<template>
  <rd-column :size="$columns.TwelveOnLg">
    <div class="row mb-1">
      <!-- <rd-form-group label="data od">
        <dx-date-box type="date" class="mr-1" @value-changed="onValueChanged" v-model="IssueDate" />
      </rd-form-group>
      <rd-form-group label="data do">
        <dx-date-box type="date" class="mr-1" @value-changed="onValueChanged" v-model="PaymentDueDate" />
      </rd-form-group> -->
      <!-- <rd-form-group label="Dział">
        <dx-lookup
                :search-enabled="true"
                :data-source="getDepartmentsDataSource"
                display-expr="Text"
                value-expr="Value"
                :closeOnOutsideClick="true"
                v-model="DepartmentId"
              >
              </dx-lookup>
      </rd-form-group>
      <rd-form-group label="Krok">
        <dx-lookup
                :search-enabled="true"
                :data-source="getStepsDataSource"
                display-expr="Text"
                value-expr="Value"
                :closeOnOutsideClick="true"
                v-model="DepartmentId"
              >
              </dx-lookup>
      </rd-form-group> -->
    </div>
    <rd-header
      :title="$t('dashboard.vinCustomReport.departmentExpiration')"
      margins="none"
      size="medium"
    />
    <div id="department-expiration-container" class="mt-2">
      <dx-data-grid
        :data-source="getVinDepartmentExpiration"
        :allow-column-resizing="true"
        :show-borders="true"
        :word-wrap-enabled="true"
      >
        <dx-group-panel
          :visible="true"
          :empty-panel-text="$('dashboard.dragColumns')"
        />
        <dx-grouping :auto-expand-all="false" :context-menu-enabled="true" />
        <dx-column :group-index="0" data-field="Branch" :caption="$('dashboard.branch')"/>
        <dx-column data-field="StepName" :caption="$('dashboard.step')" />
        <dx-column data-field="DepartmentName" :caption="$('dashboard.department')" />
        <dx-column data-field="p0_30" :caption="$('dashboard.vinReport.p0_30')" value-format="decimal" :format="formatObj"/>
        <dx-column data-field="p30_90" :caption="$('dashboard.vinReport.p30_90')" value-format="decimal" :format="formatObj"/>
        <dx-column data-field="p90_180" :caption="$('dashboard.vinReport.p90_180')" value-format="decimal" :format="formatObj"/>
        <dx-column data-field="p180_360" :caption="$('dashboard.vinReport.p180_360')" value-format="decimal" :format="formatObj"/>
        <dx-column data-field="p360_547" :caption="$('dashboard.vinReport.p360_547')" value-format="decimal" :format="formatObj" />
        <dx-column data-field="p547_650" :caption="$('dashboard.vinReport.p547_650')" value-format="decimal" :format="formatObj"/>
        <dx-column data-field="p547" :caption="$('dashboard.vinReport.p547')" value-format="decimal" :format="formatObj"/>
        <dx-column data-field="TotalSum" :caption="$('dashboard.vinReport.totalSum')" value-format="decimal" :format="formatObj"/>
        <dx-summary>
          <dx-group-item
            :show-in-group-footer="false"
            column="TotalSum"
            summary-type="sum"
            value-format="decimal"
            :display-format="decimalFormat"
          />
          <dx-group-item
            :show-in-group-footer="true"
            column="TotalSum"
            summary-type="sum"
            value-format="decimal"
            :display-format="decimalFormat"
          />
        </dx-summary>
        <dx-paging :page-size="50" />
        <dx-pager
          :show-page-size-selector="true"
          :allowed-page-sizes="[30, 50, 100]"
        />
        <dx-export
            :enabled="true"
            :file-name="getExportFileName"
        />
      </dx-data-grid>
    </div>
  </rd-column>
</template>

<script>
// @ is an alias to /src
//import Axios from 'axios';
//import router from 'vue-router';
//import sideNav from '../components/sideNav/Index'
import { mapFields } from "vuex-map-fields";
import { mapState, mapActions, mapGetters } from "vuex";
import commonMessages from "../../locales";
import localMessages from "../locales";
import {
  DxDataGrid,
  DxColumn,
  DxPager,
  DxPaging,
  DxGroupPanel,
  DxGrouping,
  DxSummary,
  DxGroupItem,
  DxExport
} from "devextreme-vue/data-grid";
import DxDateBox from "devextreme-vue/date-box";

const name = "processesStores/vinDashboardStores/indexStore";

export default {
  name: "VinDepartmentExpiration",
  created() {
    this.setVinDepartmentExpiration();
  },
  data() {
    return {
      min: 2,
      max: 2,
      formatObj: {
        minimumFractionDigits: this.min,
        maximumFractionDigits: this.max,
        type: "fixedPoint",
        precision: 2,
      },
    };
  },
  computed: {
    ...mapState(name, ["VinDepartmentExpiration"]),
    ...mapGetters(name, ["getVinDepartmentExpiration"]),
    getExportFileName(){
        return this.$t('dashboard.vinCustomReport.departmentExpiration');
    },
    customizeDecimal(value) {
      return this.$options.filters.formatDecimal2(value);
    },
  },
  methods: {
    ...mapActions(name, ["setVinDepartmentExpiration"]),
    decimalFormat(e) {
      var float = parseFloat(e.replace(',', '.'));
      var value = this.$options.filters.formatDecimal(float, 2, 2);

      return `Suma: ${value} PLN`;
    },
  },
  mounted() {},
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxPager,
    DxGroupPanel,
    DxGrouping,
    DxGroupItem,
    DxSummary,
    DxExport
  },
  i18n: {
    messages: localMessages.messages,
    sharedMessages: commonMessages.messages,
  },
};
</script>
